import { Mapper } from "planning-portal-library/src/lib/core/base";
import { LocationCountByLocationType } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count";
import { LocationCountByLocationTypeWebEntity } from "./location-count-web-entity";
import { LocationCountByProductWebEntity } from "./location-count-by-product-web-entity";
import { LocationCountByProduct } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count-by-product";

export class LocationCountByProductWebRepositoryMapper extends Mapper<
  LocationCountByProductWebEntity,
  LocationCountByProduct
> {
  constructor() {
    super();
  }

  mapFrom(param: LocationCountByProductWebEntity): LocationCountByProduct {
    return {
      productName: param.productName,
      noOfLocations: param.noOfLocations
    };
  }

  mapTo(param: LocationCountByProduct): LocationCountByProductWebEntity {
    return {
      productName: param.productName,
      noOfLocations: param.noOfLocations

    };
  }
}
